module.exports = __webpack_public_path__ + "img/banner.d7d035db.jpg";